module.exports = __webpack_public_path__ + "media/images/logos/unodor-48f4ccbe600152069fa6a654e2e8399f.png";